import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from './Navbar';
import ExperPosts from '../pages/ExperPosts';
import '../components/ExperPost.css';

const ExperPost = () => {
  const { id } = useParams(); // Use "id" instead of "postId"

  const post = ExperPosts.find(post => post.id === parseInt(id));

  return (
    <div className='exper-fullpage'>
      <head>
        <meta name="theme-color" content="#1c1c1c"/>
      </head>
      <div className='experpost-block1'>
        <Navbar></Navbar>
      </div>
      <div className='experpost-block2'>
        <Link to="/experience" className='backlink'>← Back to Experiences</Link>
        <div className="modal-content">
          <h2 className='posttitle'>{post.title}</h2>
          <p>{post.content}</p>
        </div>
      </div>
    </div>
  );
};

export default ExperPost;
